import { RESTAURANT_ZONES_FETCH } from "../action-types/restaurant-zones-types";

const initialState = {
  entities: [],
  entity: {},
  entityLoaded: false,
  loading: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case RESTAURANT_ZONES_FETCH.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case RESTAURANT_ZONES_FETCH.SUCCESS:
      return {
        ...state,
        entities: [...action.payload.data],
        loading: false,
      };
    case RESTAURANT_ZONES_FETCH.REJECTED:
      return {
        ...state,
        loading: false,
        entities: [],
      };
    default:
      return state;
  }
}
